import { render, staticRenderFns } from "./LightPackage.vue?vue&type=template&id=db0f9bf0&scoped=true"
import script from "./LightPackage.vue?vue&type=script&lang=js"
export * from "./LightPackage.vue?vue&type=script&lang=js"
import style0 from "./LightPackage.vue?vue&type=style&index=0&id=db0f9bf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0f9bf0",
  null
  
)

export default component.exports